export default function LoaderEditMineralCountryForm() {
  return (
    <div className="flex animate-pulse flex-col gap-4">
      <div className="flex w-full flex-col gap-1">
        <label
          className="font-bold"
          htmlFor="ID_MINERAL_COUNTRY_DESCRIPTION_AR"
        >
          وصف بالعربية <span className="text-danger-600">*</span>
        </label>
        <div className="h-64 w-full border-2 border-muted-500 bg-muted-300"></div>
      </div>
      <div className="flex w-full flex-col gap-1">
        <label
          className="font-bold"
          htmlFor="ID_MINERAL_COUNTRY_DESCRIPTION_AR"
        >
          وصف بالإنجليزية <span className="text-danger-600">*</span>
        </label>
        <div className="h-64 w-full border-2 border-muted-500 bg-muted-300"></div>
      </div>
      <div className="flex w-full flex-col gap-1">
        <label
          className="font-bold"
          htmlFor="ID_MINERAL_COUNTRY_DESCRIPTION_AR"
        >
          مصدر بالعربية <span className="text-danger-600">*</span>
        </label>
        <div className="h-64 w-full border-2 border-muted-500 bg-muted-300"></div>
      </div>
      <div className="flex w-full flex-col gap-1">
        <label
          className="font-bold"
          htmlFor="ID_MINERAL_COUNTRY_DESCRIPTION_AR"
        >
          مصدر بالإنجليزية <span className="text-danger-600">*</span>
        </label>
        <div className="h-64 w-full border-2 border-muted-500 bg-muted-300"></div>
      </div>
    </div>
  )
}
